import { config } from '../config';

import prod from './configureStore.prod';
import dev from './configureStore.dev';

export default function configureStore() {
    if (config.env === 'production') return prod();
    return dev();
}
